// index.js

import { cppOpenWindow, cppGetWindowPos, cppScreenSize } from "../api/cpp";

import { givenKeynoteBackup } from "../componts/App/data";

import axios from "axios";

export const openWindow = (url, x, y) => {
    if (x && y) {
        cppOpenWindow(url, x, y);
        return false;
    }
    const cunrrentWindowPos = cppGetWindowPos();
    const screenSize = cppScreenSize();
    if (!cunrrentWindowPos || !screenSize) {
        return false;
    }
    const offsetX = 320;
    const offsetY = 380;

    let posX, posY;
    if (cunrrentWindowPos.x < screenSize.width - 530) {
        posX = cunrrentWindowPos.x + offsetX;
    } else {
        posX = cunrrentWindowPos.x - offsetX;
    }

    if (cunrrentWindowPos.y < 0) {
        posY = 0;
    } else if (cunrrentWindowPos.y > screenSize.height - 648) {
        posY = screenSize.height - offsetY;
    } else {
        posY = cunrrentWindowPos.y;
    }

    cppOpenWindow(url, posX, posY);
};

export async function getImgBase64(url, cb) {
    if (!url) {
        return false;
    }
    axios({
        url: url,
        responseType: "blob",
    }).then((res) => {
        const blob = res.data;
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function (e) {
            const base64 = e.target.result || "";
            const strArray = base64.split("base64,");
            if (strArray && strArray.length > 1) {
                cb && cb(strArray[1]);
            }
        };
    });
}

// 多个基调信息取第一个
const getFirstEm = (em) => {
    if (!em || typeof em !== "string") {
        return em;
    }
    return em.split(",")[0];
};

// 特定基调备选方案
// const givenKeynoteBackup = [{
//     musicKeynote: 'C大调',
//     newKeyNote: 'A',
//     newScale: '小调',
// }, {
//     musicKeynote: 'A小调',
//     newKeyNote: 'C',
//     newScale: '大调',
// }, {
//     musicKeynote: 'D大调',
//     newKeyNote: 'B',
//     newScale: '小调',
// }, {
//     musicKeynote: 'B小调',
//     newKeyNote: 'D',
//     newScale: '大调',
// }, {
//     musicKeynote: 'E大调',
//     newKeyNote: 'C#',
//     newScale: '小调',
// }, {
//     musicKeynote: 'C#小调',
//     newKeyNote: 'E',
//     newScale: '大调',
// }, {
//     musicKeynote: 'F大调',
//     newKeyNote: 'D',
//     newScale: '小调',
// }, {
//     musicKeynote: 'D小调',
//     newKeyNote: 'F',
//     newScale: '大调',
// }, {
//     musicKeynote: 'G大调',
//     newKeyNote: 'E',
//     newScale: '小调',
// }, {
//     musicKeynote: 'E小调',
//     newKeyNote: 'G',
//     newScale: '大调',
// }, {
//     musicKeynote: 'A大调',
//     newKeyNote: 'F#',
//     newScale: '小调',
// }, {
//     musicKeynote: 'F#小调',
//     newKeyNote: 'A',
//     newScale: '大调',
// }, {
//     musicKeynote: 'B大调',
//     newKeyNote: 'G#',
//     newScale: '小调',
// }, {
//     musicKeynote: 'G#小调',
//     newKeyNote: 'B',
//     newScale: '大调',
// }]

export const initEmList = (musics) => {
    const emListData = musics.slice(0, 2);
    const emlist = [];
    emListData.forEach((ele) => {
        let newArray;
        if (!ele.musicKeynote) {
            ele.newKeyNote = "";
            ele.newScale = "";
            return ele;
        } else {
            newArray = getFirstEm(ele.musicKeynote).split(" ");
        }
        const newKeyNote = newArray[0] || "";
        let newScale = "";
        if (newArray[1].toLowerCase().indexOf("chromatic") !== -1) {
            newScale = "彩色调";
        }
        if (newArray[1].toLowerCase().indexOf("major") !== -1) {
            newScale = "大调";
        }
        if (newArray[1].toLowerCase().indexOf("minor") !== -1) {
            newScale = "小调";
        }
        ele.newKeyNote = newKeyNote;
        ele.newScale = newScale;
        // EM_KN_KX keyfinder基调
        // EM_KN_EX MIXX基调
        ele.type = ele.keynoteType || "EM_KN_KX";
        // // 排序使用
        // if (ele.type === "EM_KN_EX") {
        //     ele.s = 1
        // } else {
        //     ele.s = 0
        // }
        if (typeof ele.musicName === "string") {
            ele.musicName = ele.musicName.trim();
        }
        if (typeof ele.musicAuthor === "string") {
            ele.musicAuthor = ele.musicAuthor.trim();
        }
        emlist.push(ele);
    });
    // 如果只有一个基调 并且匹配到了特定基调 则添加第二个基调
    if (emlist.length === 1) {
        const found = getBackupEm(emlist[0]);
        if (found) {
            emlist.push({
                id: Math.random() + "",
                newKeyNote: found.newKeyNote,
                newScale: found.newScale,
                musicName: emlist[0].musicName,
                musicAuthor: emlist[0].musicAuthor,
                type: "EM_KN_CX",
            });
        }
        // EM_KN_CX 推论基调
    }
    // else {
    //     // 排序
    //     if (keynoteModel === 'ai') {
    //         emlist.sort((a, b) => {
    //             return b.s - a.s
    //         })
    //     } else {
    //         emlist.sort((a, b) => {
    //             return a.s - b.s
    //         })
    //     }
    // }
    return emlist;
};

function getBackupEm(em) {
    if (!em || !em.newKeyNote || !em.newScale) {
        return null;
    }
    if (em.newScale === "大调") {
        const found = givenKeynoteBackup.find((ele) => {
            return ele.major.includes(em.newKeyNote);
        });
        if (found) {
            return {
                newKeyNote: found.minor[0],
                newScale: "小调",
            };
        } else {
            return null;
        }
    } else {
        const found = givenKeynoteBackup.find((ele) => {
            return ele.minor.includes(em.newKeyNote);
        });
        if (found) {
            return {
                newKeyNote: found.major[0],
                newScale: "大调",
            };
        } else {
            return null;
        }
    }
}

// 判断是否存在基调
export const isNoEm = (musics) => {
    if (!musics || !musics.length) {
        return false;
    }
    return musics.some((em) => {
        return (
            typeof em.musicKeynote === "string" &&
            em.musicKeynote.indexOf("暂无基调信息") !== -1
        );
    });
};
/**
 * 格式化升降调正负值 如果不是当前基调 则返回空
 * @param {Number} value 升降调值 应该是一个数字
 * @param {Boolean} isCurrentEm 是否是当前基调
 * @returns {String}
 */
export const forMatTune = (value, isCurrentEm = true) => {
    if (!isCurrentEm || !value) {
        return "";
    }
    return value > 0 ? "+" + value : value;
};

// 验证手机号码
export function validatePhoneNum(phoneNum) {
    // const re = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-9])|([8][0-9])|([9][1,2,3,5,8,9]))[0-9]{8}$/
    const re =
        /^[1](([3][0-9])|([4][0-9])|([5][0-9])|([6][0-9])|([7][0-9])|([8][0-9])|([9][0-9]))[0-9]{8}$/;
    return re.test(phoneNum);
}

// 验证4位数字验证码
export function validateValidateCode(phoneNum) {
    const re = /^[0-9]{4}$/;
    return re.test(phoneNum);
}

/**
 * 防止抖动
 * @param {Function} fn 需要防止抖动的方法
 * @param {Number} delay 延迟时间 默认500ms
 * @returns {Function} fn
 */
export function debounce(fn, delay = 500) {
    let timer = null;
    return function () {
        const args = Array.prototype.slice.call(arguments);
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
}

// 格式化时间
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null;
    }
    if (!time) {
        return null;
    }
    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
        date = time;
    } else {
        if (("" + time).length === 10 && typeof time === "number")
            time = parseInt(time) * 1000;
        if (("" + time).indexOf("CST") !== -1) {
            time = new Date("" + time).getTime() - 14 * 60 * 60 * 1000;
        }
        date = new Date(time);
    }

    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === "a")
            return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
        if (result.length > 0 && value < 10) {
            value = "0" + value;
        }
        return value || 0;
    });
    return time_str;
}

// export function deepAssign(target, ...sources) {
//     const isObject = (obj) =>
//         obj && typeof obj === "object" && obj !== null && !Array.isArray(obj);
//     const merge = (target, source) => {
//         for (const key in source) {
//             if (isObject(source[key])) {
//                 if (!isObject(target[key])) {
//                     target[key] = {};
//                 }
//                 merge(target[key], source[key]);
//             } else {
//                 target[key] = source[key];
//             }
//         }
//     };
//     sources.forEach((source) => {
//         if (isObject(source)) {
//             merge(target, source);
//         }
//     });
//     return target;
// }

/**
 * 从路径中移除末尾的版本号部分
 * 例如: "C:\Program Files\emusicv3\3.9.7" → "C:\Program Files\emusicv3"
 * @param {String} path 路径字符串
 * @returns {String} 移除版本号后的路径
 */
export function removeVersionFromPath(path) {
    if (typeof path !== 'string' || !path) {
        return path;
    }
    // 匹配路径末尾的版本号段（如 \3.9.7 或 /3.10.0）
    return path.replace(/[\\/]\d+(\.\d+)+\s*$/, '');
}

// 比较版本号 v1是否比v2大
export function compareVersions(v1, v2) {
    // 处理空值情况
    if (!v1 || !v2) {
        return false;
    }

    // 分割版本号为数组
    const parts1 = v1.split(".").map(Number);
    const parts2 = v2.split(".").map(Number);

    // 统一长度，不足的补0
    const maxLength = Math.max(parts1.length, parts2.length);
    while (parts1.length < maxLength) parts1.push(0);
    while (parts2.length < maxLength) parts2.push(0);

    // 逐段比较
    for (let i = 0; i < maxLength; i++) {
        if (parts1[i] > parts2[i]) {
            return true
        } else if (parts1[i] < parts2[i]) {
            return false
        }
    }
    return false;
}
